<template>
  <section class="listing">
    <AnalyticsDetail
      v-if="details"
      :id="detailsId"
      :iniDate="iniDate"
      :endDate="endDate"
      :close="closeDetails"
      :title="detailsTitle"
    />
    <div class="header">
      <div class="title">Analytics</div>
    </div>
    <form @submit.prevent class="form form-search">
      <input v-model="iniDate" @change="getData" type="date" />
      <input v-model="endDate" @change="getData" type="date" />
      <button @click="exportData" type="button" class="btn-export">
        <i v-if="!exporting" class="fas fa-file-excel"></i>
        <i v-else class="fas fa-spinner loading"></i>
      </button>
    </form>
    <transition name="show" mode="out-in">
      <i v-if="loading" class="fas fa-spinner loading-big"></i>
      <div v-if="!loading" style="margin-top: 10px">
        <!-- Captions -->
        <div class="analytics-captions">
          <div class="analytics-item-bar">
            <div class="bar-bar" style="width: 30px"></div>
            <div class="bar-value">ACESSOS</div>
          </div>
          <div class="analytics-item-bar bar-2">
            <div class="bar-bar" style="width: 30px"></div>
            <div class="bar-value">AQUISIÇÃO</div>
          </div>
          <div class="analytics-item-bar bar-3">
            <div class="bar-bar" style="width: 30px"></div>
            <div class="bar-value">CADASTROS</div>
          </div>
          <div class="analytics-caption">
            <i class="fas fa-desktop"></i>
            <span>{{ data.accessWeb }}</span>
          </div>
          <div class="analytics-caption">
            <i class="fas fa-mobile-alt"></i>
            <span>{{ data.accessApp }}</span>
          </div>
        </div>
        <!-- Graphic -->
        <div style="position: relative; height: 125px">
          <canvas id="chartAccess"></canvas>
        </div>
        <!-- Tiketera -->
        <div v-if="data.accessTotal > 0" @click="openDetails(0, 'Swiss Money')" class="analytics-item">
          <div class="analytics-item-img"><img src="img/swiss.png" class="img-logo" /></div>
          <div class="analytics-item-data">
            <div class="analytics-item-name">Swiss Money</div>
            <div class="analytics-item-bar">
              <div class="bar-bar" :style="`width: ${getPercent(data.accessTotal, data.accessTotal)}%`"></div>
              <div class="bar-value">{{ data.accessTotal }} <span>(100%)</span></div>
            </div>
            <div class="analytics-item-bar bar-2">
              <div class="bar-bar" :style="`width: ${getPercent(data.boughtTotal, data.accessTotal)}%`"></div>
              <div class="bar-value">{{ data.boughtTotal }} <span>({{ getPercent(data.boughtTotal, data.accessTotal) }}%)</span></div>
            </div>
            <div class="analytics-item-bar bar-3">
              <div class="bar-bar" :style="`width: ${getPercent(data.signonTotal, data.accessTotal)}%`"></div>
              <div class="bar-value">{{ data.signonTotal }} <span>({{ getPercent(data.signonTotal, data.accessTotal) }}%)</span></div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import logger from '../../logger'
import { get, getExport } from '../api/analytics'
import AnalyticsDetail from './AnalyticsDetail.vue'
import Chart from 'chart.js'

export default {
  components: { AnalyticsDetail },
  data () {
    return {
      APP_IMG: process.env.VUE_APP_IMG,
      loading: true,
      iniDate: null,
      endDate: null,
      data: [],
      details: false,
      detailsId: null,
      detailsTitle: null,
      exporting: false
    }
  },
  async mounted () {
    try {
      const date = new Date()
      this.endDate = date.toISOString().split('T')[0]
      date.setDate(date.getDate() - 7)
      this.iniDate = date.toISOString().split('T')[0]
      this.getData()
    } catch (error) {
      logger.error(error)
    }
  },
  methods: {
    async exportData () {
      this.exporting = true
      try {
        const file = await getExport(this.iniDate, this.endDate)
        const url = window.URL.createObjectURL(new Blob([file]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'Analytics.xls')
        document.body.appendChild(link)
        link.click()
        link.remove()
      } catch (error) {
        logger.error(error)
      }
      this.exporting = false
    },
    openDetails (id, title) {
      this.detailsId = id
      this.detailsTitle = title
      this.details = true
    },
    closeDetails () {
      this.details = false
    },
    async getData () {
      this.loading = true
      try {
        const data = await get(this.iniDate, this.endDate)
        this.data = data
      } catch (error) {
        logger.error(error)
      }
      this.loading = false
      this.createGraph()
    },
    getPercent (value, total) {
      return Math.round(value / total * 100)
    },
    createGraph () {
      // this.$nextTick(() => {
      setTimeout(() => {
        const ini = new Date(this.iniDate + ' 12:00:00')
        const end = new Date(this.endDate + ' 12:00:00')
        end.setDate(end.getDate() + 1)
        const data = []
        while (ini.toISOString().split('T')[0] !== end.toISOString().split('T')[0]) {
          const found = this.data.graphic.find(x => x.groupDate.split(' ')[0] === ini.toISOString().split('T')[0])
          data.push({
            date: new Date(ini),
            access: found ? Number(found.access) : 0,
            bought: found ? Number(found.bought) : 0
          })
          ini.setDate(ini.getDate() + 1)
        }
        // eslint-disable-next-line no-unused-vars
        const graph = new Chart(document.getElementById('chartAccess'), {
          type: 'line',
          data: {
            // labels: this.data.graphic.map(x => new Date(x.groupDate)),
            labels: data.map(x => x.date),
            datasets: [
              {
                type: 'line',
                label: 'Compras',
                borderColor: '#4caf50',
                borderWidth: 1.5,
                backgroundColor: '#4caf50',
                fill: 'origin',
                pointRadius: 2,
                // data: this.data.graphic.map(x => Number(x.bought))
                data: data.map(x => x.bought)
              },
              {
                type: 'line',
                label: 'Acessos',
                borderColor: '#0071b3',
                borderWidth: 1.5,
                backgroundColor: '#0071b3',
                fill: 'origin',
                pointRadius: 2,
                // data: this.data.graphic.map(x => Number(x.access))
                data: data.map(x => x.access)
              }
            ]
          },
          options: {
            maintainAspectRatio: false,
            spanGaps: true,
            layout: {
              padding: {
                left: 10,
                right: 10,
                top: 10,
                bottom: 5
              }
            },
            tooltips: {
              mode: 'index'
            },
            legend: {
              display: false
            },
            scales: {
              yAxes: [{
                display: false,
                ticks: {
                  beginAtZero: true
                }
              }],
              xAxes: [{
                gridLines: {
                  drawBorder: true,
                  drawOnChartArea: false,
                  tickMarkLength: 5
                },
                type: 'time',
                ticks: {
                  min: new Date(this.iniDate + ' 12:00:00'),
                  max: new Date(this.endDate + ' 12:00:00'),
                  maxTicksLimit: 7,
                  maxRotation: 0
                },
                time: {
                  round: 'day',
                  unit: 'day',
                  displayFormats: {
                    day: 'DD'
                  },
                  tooltipFormat: 'DD/MM'
                }
              }]
            }
          }
        })
      // })
      }, 2000)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.analytics-captions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-evenly;
  padding: 10px 0;
}

.analytics-caption {
  color: #dfdddd;
  i {
    padding: 0 10px;
  }
  span {
    font-weight: bold;
  }
}

.analytics-item {
  display: flex;
  align-items: center;
  height: 90px;
  margin: 10px 0;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    background-color: $dark-color;
  }
}

.analytics-item-img {
  width: 100px;
  padding-left: 5px;
  padding-right: 10px;
  img {
    width: 100%;
    height: auto;
    object-fit: contain;
    border-radius: 5px;
  }
  .img-logo {
    border-radius: 5px;
    background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
    height: 50px;
    padding: 10px;
    width: calc(100% - 20px);
  }
}

.analytics-item-data {
  flex-grow: 1;
}

.analytics-item-name {
  font-size: 1.1em;
  color: #b6b3b3;
}

.analytics-item-bar {
  display: flex;
  align-items: center;
  margin: 5px 0;
  &.bar-2 {
    .bar-bar {
      border: 1px solid #3ff448;
      background-image: linear-gradient(to bottom right, #3ff448, #3ff448);
    }
    .bar-value {
      color: #3ff448;
    }
  }
  &.bar-3 {
    .bar-bar {
      border: 1px solid #f4c73f;
      background-image: linear-gradient(to bottom right, #f4c73f, #f4c73f);
    }
    .bar-value {
      color: #f4c73f;
    }
  }
}

.bar-bar {
  border-radius: 3px;
  border: 1px solid #4cb1eb;
  background-image: linear-gradient(to bottom right, #4cb1eb, #4cb1eb);
  height: 15px;
  min-width: 6px;
  transition: width 2s;
}

.bar-value {
  flex-shrink: 0;
  font-size: 1em;
  font-weight: 500;
  color: #4cb1eb;
  padding: 0 5px;
  span {
    font-weight: 400;
  }
}

.form-search {
  display: flex;
  flex-direction: row;
  padding: 0;
  padding-bottom: 10px;

  input {
    flex: 1;
    margin: 0 5px;
  }
}

.btn-export {
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  width: 39px;
  height: 39px;
  color: #fff;
  border-radius: 50%;
  border: 1px solid $primary-color;
  cursor: pointer;
  font-size: 1.1em;
  margin-left: 5px;
  &:focus {
    outline: 0;
  }
}

// Desktop
@media screen and (min-width: $desktop-width) {
}
</style>
